var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStates(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 16.829V11.1623C21 10.1187 21 9.59692 20.7169 9.20409C20.4881 8.88676 20.1212 8.7181 19.4667 8.49103C19.3328 10.0972 18.8009 11.7375 17.9655 13.1732C16.9928 14.8448 15.5484 16.3393 13.697 17.147C12.618 17.6177 11.382 17.6177 10.303 17.147C8.45164 16.3393 7.00718 14.8448 6.03449 13.1732C5.40086 12.0842 4.9418 10.8776 4.69862 9.65733C4.31607 9.60099 4.0225 9.6299 3.76917 9.77124C3.66809 9.82763 3.57388 9.89553 3.48841 9.97359C3 10.4197 3 11.2491 3 12.908V17.8377C3 18.8813 3 19.4031 3.28314 19.7959C3.56627 20.1888 4.06129 20.3538 5.05132 20.6838L5.43488 20.8116L5.43489 20.8116C7.01186 21.3373 7.80035 21.6001 8.60688 21.6017C8.8498 21.6021 9.09242 21.5849 9.33284 21.5501C10.131 21.4345 10.8809 21.0596 12.3806 20.3097C13.5299 19.7351 14.1046 19.4477 14.715 19.3144C14.9292 19.2676 15.1463 19.235 15.3648 19.2167C15.9875 19.1646 16.6157 19.2693 17.8721 19.4787C19.1455 19.6909 19.7821 19.797 20.247 19.5301C20.4048 19.4394 20.5449 19.3208 20.6603 19.18C21 18.7654 21 18.1199 21 16.829Z",
    fill: "url(#paint0_linear_1651_41543)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C8.68629 2 6 4.55211 6 7.70031C6 10.8238 7.91499 14.4687 10.9028 15.7721C11.5993 16.076 12.4007 16.076 13.0972 15.7721C16.085 14.4687 18 10.8238 18 7.70031C18 4.55211 15.3137 2 12 2ZM12 10C13.1046 10 14 9.10457 14 8C14 6.89543 13.1046 6 12 6C10.8954 6 10 6.89543 10 8C10 9.10457 10.8954 10 12 10Z",
    fill: "url(#paint1_linear_1651_41543)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1651_41543",
    x1: 13.1674,
    y1: 8.49103,
    x2: 13.1674,
    y2: 21.6017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2ABDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0497FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1651_41543",
    x1: 12.7782,
    y1: 2,
    x2: 12.7782,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2ABDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0497FD"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStates);
export default __webpack_public_path__ + "static/media/states.45939b4755cd4fa3aab6eed3621c423f.svg";
export { ForwardRef as ReactComponent };